export function initializeAjaxModals() {
  document.addEventListener("click", async (event) => {
    const trigger = event.target.closest("[data-modal-url]")
    if (!trigger) return

    event.preventDefault()

    const spinner = document.getElementById("modal-loading")

    trigger.disabled = true
    spinner?.classList.remove("d-none")

    try {
      const response = await fetch(trigger.dataset.modalUrl, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      const html = await response.text()

      document.getElementById(
        trigger.dataset.modalContent || "modal_content"
      ).innerHTML = html

      bootstrap.Modal
        .getOrCreateInstance(
          document.getElementById(trigger.dataset.modalId || "ajaxModal")
        )
        .show()
    } finally {
      spinner?.classList.add("d-none")
      trigger.disabled = false
    }
  })
}